import { render, staticRenderFns } from "./Gantt_new.vue?vue&type=template&id=3fadccb6&scoped=true&"
import script from "./Gantt_new.vue?vue&type=script&lang=js&"
export * from "./Gantt_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadccb6",
  null
  
)

export default component.exports